(() => {
  const SHARE_MESSAGE = 'Get a free Gymkhana sauce on your first order:';
  const COPY_FEEDBACK_MS = 1800;
  const MOCK_PARAM = 'referral_mock';
  const LOG_PREFIX = '[ReferralLanding]';

  const isMockMode = () => new URLSearchParams(window.location.search).has(MOCK_PARAM);

  const waitForRecharge = async (timeoutMs = 5000) => {
    const start = Date.now();

    while (typeof window.recharge === 'undefined' || !window.recharge.auth) {
      if (Date.now() - start > timeoutMs) {
        throw new Error('Recharge SDK did not load within ' + timeoutMs + 'ms');
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  };

  const fetchReferralUrl = async () => {
    if (isMockMode()) return 'https://rc-refer.com/mock-test-link';

    await waitForRecharge();

    const session = await window.recharge.auth.loginShopifyAppProxy();

    if (!session?.customerId) {
      console.warn(LOG_PREFIX, 'Customer not found in Recharge yet — they need at least one order.');
      return null;
    }

    const customerData = await window.recharge.customer.getCustomer(session, {
      include: ['referral_info'],
    });

    return (
      customerData?.referral_info?.referral_url?.url ||
      customerData?.include?.referral_info?.referral_url?.url ||
      null
    );
  };

  const bindCopy = (button, input, url) => {
    const defaultText = button.querySelector('[data-copy-default]');
    const successText = button.querySelector('[data-copy-success]');

    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
      } catch {
        input.select();
        document.execCommand('copy');
      }

      defaultText.hidden = true;
      successText.hidden = false;

      setTimeout(() => {
        defaultText.hidden = false;
        successText.hidden = true;
      }, COPY_FEEDBACK_MS);
    });
  };

  const bindShareLinks = (shareBlock, url) => {
    const message = `${SHARE_MESSAGE} ${url}`;
    const encodedMessage = encodeURIComponent(message);
    const encodedUrl = encodeURIComponent(url);

    const targets = {
      whatsapp: `https://wa.me/?text=${encodedMessage}`,
      email: `mailto:?subject=${encodeURIComponent('A free sauce from me to you')}&body=${encodedMessage}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodedMessage}`,
    };

    for (const [name, href] of Object.entries(targets)) {
      const link = shareBlock.querySelector(`[data-share="${name}"]`);
      if (link) link.href = href;
    }
  };

  const renderError = (errorEl, err) => {
    console.error(LOG_PREFIX, err);
    if (!errorEl) return;
    errorEl.textContent = "We couldn't load your referral link. Please refresh or try again later.";
    errorEl.hidden = false;
  };

  const initSection = async (section) => {
    if (section.dataset.customerLoggedIn !== 'true') return;

    const referralBlock = section.querySelector('[data-referral-block]');
    const shareBlock = section.querySelector('[data-referral-share]');
    const errorEl = section.querySelector('[data-referral-error]');
    const urlInput = section.querySelector('[data-referral-url]');
    const copyBtn = section.querySelector('[data-referral-copy]');

    if (!referralBlock || !urlInput || !copyBtn) return;

    try {
      const url = await fetchReferralUrl();
      if (!url) throw new Error('No referral URL available for this customer.');

      urlInput.value = url;
      referralBlock.hidden = false;
      if (shareBlock) shareBlock.hidden = false;

      bindCopy(copyBtn, urlInput, url);
      if (shareBlock) bindShareLinks(shareBlock, url);
    } catch (err) {
      renderError(errorEl, err);
    }
  };

  const init = () => {
    for (const section of document.querySelectorAll('[data-referral-landing]')) {
      initSection(section);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
